<!-- .topbar -->
<div class="site-header__topbar topbar">
    <div class="topbar__container container">
        <div class="topbar__row">
            <div class="topbar__item topbar__item--link">
                <a class="topbar-link" routerLink="/about">{{ 'about-us' | t:'About Us' }}</a>
            </div>
            <!-- <div class="topbar__item topbar__item--link">
                <a class="topbar-link" routerLink="/contact">Contacts</a>
            </div> -->
            <!-- <div class="topbar__item topbar__item--link">
                <a class="topbar-link" routerLink="">Store Location</a>
            </div> -->
            <div class="topbar__item topbar__item--link">
                <a class="topbar-link" routerLink="/track-order">{{ 'track-order' | t:'Track Order' }}</a>
            </div>
            <div class="topbar__item topbar__item--link">
                <a class="topbar-link" routerLink="/blog">{{ 'blog' | t:'Blog' }}</a>
            </div>
            <div class="topbar__spring"></div>
            <div class="topbar__item">
                <div class="topbar-dropdown" appDropdown="topbar-dropdown--opened" #accountDropdown="appDropdown">
                    <button class="topbar-dropdown__btn" type="button" (click)="accountDropdown.toggle()">
                        {{ 'my-account' | t:'My Account' }}
                        <app-icon name="arrow-rounded-down-7x5" size="7x5"></app-icon>
                    </button>

                    <div class="topbar-dropdown__body">
                        <!-- A seller's own console, not a shopper's pages (the owner, 2026-11-02). -->
                        <app-header-menu *ngIf="isLoggedIn && isSeller" layout="topbar" (itemClick)="accountDropdown.close()" [items]="[
                            {key: 'dashboard', label: 'Dashboard', url: '/account/shop/dashboard'},
                            {key: 'orders', label: 'Orders', url: '/account/shop/orders'},
                            {key: 'products', label: 'Products', url: productsUrl},
                            {key: 'chat-inbox', label: 'Inbox', url: '/account/chat'},
                            {key: 'shop-settings', label: 'Shop settings', url: '/account/shop'},
                            {key: 'profile', label: 'Profile', url: '/account/myaccount'}
                        ]"></app-header-menu>

                        <app-header-menu *ngIf="isLoggedIn && !isOwner && !isSeller" layout="topbar" (itemClick)="accountDropdown.close()" [items]="[
                            {key: 'profile', label: 'Profile',  url: '/account/myaccount'},
                            {key: 'order-history', label: 'Order History', url: '/account/orders'},
                            {key: 'addresses', label: 'Addresses',     url: '/account/addresses'},
                            {key: 'wish-list', label: 'Wish List',     url: '/account/wishlist'},
                            {key: 'compare-items', label: 'Compare Items',     url: '/account/compare'}
                        ]"></app-header-menu>

                        <!-- Owner gets the admin screens first: they are the reason the owner
                             opens this menu at all. Product Sources is the crawler console -
                             worker health, the import queue, and price/stock refresh status. -->
                        <app-header-menu *ngIf="isLoggedIn && isOwner" layout="topbar" (itemClick)="accountDropdown.close()" [items]="[
                            {key: 'dashboard', label: 'Dashboard', url: '/account/dashboard'},
                            {key: 'orders', label: 'Orders', url: '/account/orders'},
                            {key: 'shop-requests', label: 'Shop requests', url: '/account/shop-requests'},
                            {key: 'product-approval', label: 'Product approval', url: '/account/pending-products'},
                            {key: 'sellers', label: 'Sellers', url: '/account/sellers'},
                            {key: 'payments', label: 'Payments', url: '/account/payments'},
                            {key: 'profile', label: 'Profile', url: '/account/myaccount'}
                        ]"></app-header-menu>

                        <app-header-menu *ngIf="!isLoggedIn" layout="topbar" (itemClick)="accountDropdown.close()" [items]="[
                            {key: 'login', label: 'Login',        url: '/account/login'}
                        ]"></app-header-menu> 
                    </div>
                </div>
            </div>
            <!-- What prices are shown in, and where: taka and Bangladesh for everybody (SiteCountry on the server). -->
            <div class="topbar__item">
                <div class="topbar-dropdown">
                    <button class="topbar-dropdown__btn" type="button">
                        {{ 'currency-label' | t:'Currency:' }} <span class="topbar__item-value">{{ currencyService.options.code }}</span>
                    </button>
                </div>
            </div>
            <div class="topbar__item">
                <div><span style="max-width: 23px; max-height: 16px;" class="flag {{ countryInfo | countryFlag }}"></span></div>
            </div>
            <!-- The other language: this page's own version in it where it has one (a SitePage, a post, the home page),
                 else that language's home page. -->
            <div class="topbar__item topbar__item--link">
                <!-- A plain link, a full page load: a page's language is fixed while it is open (Multilang_Culture_Spec.md 5.1). -->
                <a class="topbar-link" [attr.href]="languageSwitch.url" [attr.hreflang]="languageSwitch.lang" [attr.lang]="languageSwitch.lang"
                   (click)="chooseLanguage(languageSwitch.lang)">{{ languageSwitch.label }}</a>
            </div>
        </div>
    </div>
</div>
<!-- .topbar / end -->
